<template>
   <el-tabs type="border-card">
    <el-tab-pane label="文章列表">
      <div style="margin-top:16px;" >
        <el-form :inline="true" :model="aritcleForm" class="demo-form-inline">
          <el-form-item label="文章标题">
            <el-input size="mini" v-model.trim="aritcleForm.title" placeholder="文章标题"></el-input>
          </el-form-item>
          <el-form-item label="文章关键字">
            <el-input size="mini" v-model.trim="aritcleForm.keywords" placeholder="文章关键字"></el-input>
          </el-form-item>
          <el-form-item label="伪原创">
            <el-select v-model.trim="aritcleForm.isPseudo" placeholder="伪原创">
              <el-option label="全部" value=""></el-option>
              <el-option label="已提交" value="1"></el-option>
              <el-option label="未提交" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否发布">
            <el-select v-model.trim="aritcleForm.isShow" placeholder="是否发布">
              <el-option label="全部" value=""></el-option>
              <el-option label="已发布" value="1"></el-option>
              <el-option label="未发布" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属类型">
            <el-select v-model.trim="aritcleForm.tagId" placeholder="所属类型">
              <el-option label="全部" value=""></el-option>
              <el-option label="公告" value="1"></el-option>
              <el-option label="动态" value="4"></el-option>
              <el-option label="方案" value="8"></el-option>
              <el-option label="技术" value="9"></el-option>
              <el-option label="产品" value="10"></el-option>
              <el-option label="新闻" value="11"></el-option>
              <el-option label="元器件百科" value="12"></el-option>
              <el-option label="电路图" value="13"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="预发布">
            <el-select v-model.trim="aritcleForm.isYfb" placeholder="预发布">
              <el-option label="全部" value=""></el-option>
              <el-option label="预发布" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="primary" @click="onSubmit" icon="el-icon-search">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-button size="mini" type="primary" @click="onAdd" icon="el-icon-circle-plus-outline">新增</el-button>
      </div>
      <div style="margin-top:10px;">
        <el-table
          :data="data"
          border>
          <el-table-column
            prop="id"
            label="ID编号"
            width="90">
          </el-table-column>
          <el-table-column
            prop="title"
            width="200"
            show-overflow-tooltip
            label="文章标题">
          </el-table-column>
          <el-table-column
            prop="introduction"
            show-overflow-tooltip
            label="文章简介">
          </el-table-column>
          <el-table-column
            prop="keywords"
            show-overflow-tooltip
            width="160"
            label="文章关键字">
          </el-table-column>
          <el-table-column
            width="80"
            label="是否发布">
            <template slot-scope="scope">
              <span v-if="scope.row.isShow == 1" style="color:#67C23A">已发布</span>
              <span v-if="scope.row.isShow == 2" style="color:#F56C6C">未发布</span>
            </template>
          </el-table-column>
          <el-table-column
            width="80"
            label="伪原创">
            <template slot-scope="scope">
              <span v-if="scope.row.isPseudo == 1" style="color:#67C23A">是</span>
              <span v-if="scope.row.isPseudo == 2" style="color:#F56C6C">否</span>
            </template>
          </el-table-column>
          <el-table-column
            width="80"
            label="预发布">
            <template slot-scope="scope">
              <span v-if="scope.row.isYfb == 1" style="color:#67C23A">是</span>
              <span v-if="scope.row.isYfb == 0" style="color:#F56C6C">否</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="tagId"
            width="80"
            label="所属类型">
            <template slot-scope="scope">
              <span v-if="scope.row.tagId == 1">公告</span>
              <span v-if="scope.row.tagId == 4">动态</span>
              <span v-if="scope.row.tagId == 8">方案</span>
              <span v-if="scope.row.tagId == 9">技术</span>
              <span v-if="scope.row.tagId == 10">产品</span>
              <span v-if="scope.row.tagId == 11">新闻</span>
              <span v-if="scope.row.tagId == 12">元器件百科</span>
              <span v-if="scope.row.tagId == 13">电路图</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="typeId"
            width="80"
            label="所属标签">
          </el-table-column>
          <el-table-column
            width="240"
            prop="createDate"
            label="创建时间">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="220">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.row)">编辑</el-button>
            <el-popconfirm
                @confirm="handleDelete(scope.row, scope.$index)"
                title="确定删除这条记录吗？">
                <el-button slot="reference"
                type="danger"
                size="mini">删除</el-button>
              </el-popconfirm>  
            <el-popconfirm v-if="scope.row.isShow == 2 && scope.row.isPseudo == 1"
                @confirm="handlePush(scope.row, scope.$index)"
                title="确定发布这条记录吗？">
                <el-button slot="reference"
                type="danger"
                size="mini">发布</el-button>
              </el-popconfirm>  
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
   </el-tabs>
</template>
<script>
import pagination from "../../common/util/pagination";
export default {
  data() {
    return {
      data: [],
      aritcleForm: {
        title: '',
        isYfb: '',
        token: this.user.getToken(),
      },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      }
    };
  },
  components: {
    pagination
  },
  mounted: function() {
    this.getAritcleList()
  },
  methods: {
    getAritcleList: function() {
      this.optionItem = this.common.extend(this.aritcleForm, this.pagination)
      // 初始化默认加载菜单
      this.http.post(
        '/article/list',
        this.optionItem, res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        });
    },
    onSubmit: function() {
      this.pagination.pageNum = 1
      this.getAritcleList()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getAritcleList()
    },
    onAdd: function() {
      this.$router.push("/aritcle/add")
    },
    handleEdit: function(row) {
      this.$router.push({name:'aritcleEditor',params:row})
    },
    handleDelete: function(row, index) {
      this.optionItem = this.common.extend({'token':this.user.getToken()}, row)
      this.http.post(
        '/article/delete',
        this.optionItem, res => {
          if (res.success) {
            // 返回正确的处理
            this.$router.push("/article/list")
            this.data.splice(index, 1);
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    handlePush: function(row, index) {
      this.optionItem = this.common.extend({'token':this.user.getToken()}, row)
      this.http.post(
        '/article/push', 
        this.optionItem, res => {
          if (res.success) {
            // 返回正确的处理
            this.$router.push("/article/list")
            this.data.splice(index, 1);
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    }
  }
};
</script>


<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>


// WEBPACK FOOTER //
// src/components/views/aritcle/aritcleList.vue